import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowLeft, Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

export default function ComingSoonPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F7F9FB] flex flex-col items-center justify-center px-4 py-12">
      {/* Logo */}
      <div className="mb-8 animate-fadeIn">
        <Logo size="medium" />
      </div>

      {/* Content Card */}
      <div className="bg-white rounded-2xl shadow-soft p-8 max-w-md w-full text-center animate-fadeIn" style={{ animationDelay: '0.1s' }}>
        {/* Icon */}
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#4FB3A5] to-[#3d9a8d] flex items-center justify-center mx-auto mb-6 shadow-lg">
          <Sparkles className="text-white" size={32} />
        </div>

        {/* Title */}
        <h1 className="font-serif text-2xl sm:text-3xl font-bold text-[#1F3A5F] mb-4">
          Coming Soon!
        </h1>

        {/* Message */}
        <p className="text-[#6B7280] leading-relaxed mb-6">
          We're putting the finishing touches on the Early Access signup. 
          Check back soon to be among the first to unlock Pro features, unlimited rewrites, and exclusive perks.
        </p>

        {/* Status Badge */}
        <div className="inline-flex items-center gap-2 bg-[#EAF6F4] text-[#4FB3A5] px-4 py-2 rounded-full text-sm font-medium mb-6">
          <Bell size={16} />
          Launching very soon
        </div>

        {/* Back Button */}
        <Button
          onClick={() => navigate("/")}
          className="w-full py-5 rounded-xl bg-[#1F3A5F] hover:bg-[#2a4a75] text-white font-medium"
          data-testid="back-to-app-btn"
        >
          <ArrowLeft size={18} className="mr-2" />
          Back to App
        </Button>
      </div>

      {/* Footer */}
      <p className="mt-8 text-sm text-[#A0A7B4] animate-fadeIn" style={{ animationDelay: '0.2s' }}>
        Thanks for your patience — great things are coming!
      </p>
    </div>
  );
}
